export default [
  {
    path: "billing",
    name: "billing",
    component: () => import("@/views/adminPanel/pages/billing/Billing.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "billing/done",
    name: "billing/done",
    component: () => import("@/views/adminPanel/pages/billing/Done.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "BillingIframe",
    name: "BillingIframe",
    component: () =>
      import("@/views/adminPanel/pages/billing/components/BilllingIframe.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "coming",
    name: "coming",
    component: () => import("@/views/adminPanel/pages/coming/Coming.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "coming-mobile",
    name: "coming-mobile",
    component: () =>
      import("@/views/adminPanel/pages/coming/Coming-mobile.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "junk",
    name: "junk",
    component: () => import("@/views/adminPanel/pages/junk/Junk.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "shopping",
    name: "shopping",
    component: () => import("@/views/adminPanel/pages/shopping/Shopping.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "File",
    name: "File",
    component: () => import("@/views/adminPanel/pages/file/File.vue"),
    meta: {
      rule: "editor",
    },
  },

];
